import { eligibility } from "../data";
import SectionHeading from "./SectionHeading";

export default function EligibilitySection() {
  return (
    <section id="eligible" className="bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <SectionHeading
          align="center"
          eyebrow="Eligibility"
          title="参赛条件"
          desc="门槛不高，但每一条都会在初审时逐项核验。对照下面这份清单自查一遍，能少走不少弯路。"
        />

        <ul className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {eligibility.map((item) => (
            <li
              key={item.text}
              className="flex items-start gap-4 p-5 rounded-lg bg-background-100 border border-background-200 hover:border-secondary-300 transition-colors"
            >
              <span className="w-11 h-11 shrink-0 rounded-md bg-secondary-100 text-secondary-800 flex items-center justify-center">
                <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <p className="text-sm text-foreground-700 leading-relaxed pt-1.5">{item.text}</p>
            </li>
          ))}
        </ul>

        <p className="mt-8 text-center text-xs md:text-sm text-foreground-500">
          不确定自己是否符合条件？先把作品写出来，初审反馈会告诉你哪里需要调整。
        </p>
      </div>
    </section>
  );
}